import { useReCaptcha } from '@/core/recaptcha/useReCaptcha';
import BodyField from './fields/BodyField';
import EmailField from './fields/EmailField';
import NameField from './fields/NameField';
import PrivacyNote from './fields/PrivacyNote';
import SendButton from './fields/SendButton';
import SubjectField from './fields/SubjectField';

export default function ContactForm() {
  useReCaptcha();
  return (
    <div className="bg-white text-black mt-12 p-6 md:p-10 rounded-3xl M16 flex-col max-w-[600px] m-auto">
      <NameField />
      <EmailField />
      <SubjectField />
      <BodyField />
      <PrivacyNote />
      <SendButton />
    </div>
  );
}
